<div class="bg-gray-300 p-4">
    <span>Macro</span>
</div>
<div class="mb-2 border bg-white p-4">
    @for (param of params(); track $index) {
        <div class="flex gap-x-1">
            <span class="font-medium">{{ param.macros }}</span>
            <span>-</span>
            <span>{{ param.description }}</span>
        </div>
    }
</div>
